import React from 'react'
import Typewriter from "typewriter-effect";

export default function Typewrite() {
  return (
    <>
      <h1 className="mb-5 fs-1 text-center my-5">Nuestra Ubicaion exacta </h1>
      <section className="mb-5 fs-1 text-center colorsito">
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Carr. la Isabela, Pantoja 10126")
              .pauseFor(200)
              .start();
          }}
        />
      </section>
    </>
  );
}
